var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", "close-on-content-click": false },
      on: { close: _vm.handleDatesFilterChange },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      class: _vm.classes,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _vm.dateMin && !_vm.dateMax
                                  ? _c("div", [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.boilerplate.filters.from",
                                              {
                                                date: _vm.formatDateToInputDate(
                                                  new Date(_vm.dateMin)
                                                )
                                              }
                                            )
                                          ) +
                                          "\n        "
                                      )
                                    ])
                                  : _vm.dateMax && !_vm.dateMin
                                  ? _c("div", [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.boilerplate.filters.til",
                                              {
                                                date: _vm.formatDateToInputDate(
                                                  new Date(_vm.dateMax)
                                                )
                                              }
                                            )
                                          ) +
                                          "\n        "
                                      )
                                    ])
                                  : _vm.dateMax && _vm.dateMin
                                  ? _c("div", [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.boilerplate.filters.fromTo",
                                              {
                                                dateMin: _vm.formatDateToInputDate(
                                                  new Date(_vm.dateMin)
                                                ),
                                                dateMax: _vm.formatDateToInputDate(
                                                  new Date(_vm.dateMax)
                                                )
                                              }
                                            )
                                          ) +
                                          "\n        "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(_vm.noFilterLabel) +
                                          "\n        "
                                      )
                                    ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-btn",
                    _vm.$attrs,
                    false
                  ),
                  on
                )
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pa-3 background" },
        [
          _c("v-text-field", {
            attrs: {
              label: _vm.generateMessage("boilerplate.filters.dateMin"),
              clearable: "",
              type: _vm.type,
              outlined: "",
              max: _vm.newDateMax
            },
            model: {
              value: _vm.newDateMin,
              callback: function($$v) {
                _vm.newDateMin = $$v
              },
              expression: "newDateMin"
            }
          }),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              label: _vm.generateMessage("boilerplate.filters.dateMax"),
              type: _vm.type,
              clearable: "",
              outlined: "",
              min: _vm.newDateMin
            },
            model: {
              value: _vm.newDateMax,
              callback: function($$v) {
                _vm.newDateMax = $$v
              },
              expression: "newDateMax"
            }
          }),
          _vm._v(" "),
          _c("v-btn", { on: { click: _vm.handleDatesFilterChange } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.generateMessage("boilerplate.filters.validate")) +
                "\n    "
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }